import AsyncStorage from '@react-native-async-storage/async-storage'

import { getScopedStorageKey } from './storage-scope'

export const AUTH_SESSION_STORAGE_KEY = 'auth.session.isAuthenticated'

export const getStoredIsAuthenticated = async (
  userId?: string | null,
): Promise<boolean> => {
  try {
    const scopedKey = await getScopedStorageKey(AUTH_SESSION_STORAGE_KEY, {
      requireUserScope: true,
      userId,
    })
    if (scopedKey == null) {
      return false
    }

    const isAuthenticated = await AsyncStorage.getItem(scopedKey)
    return isAuthenticated === '1'
  } catch {
    return false
  }
}

export const setStoredIsAuthenticated = async (params: {
  isAuthenticated: boolean
  userId: string | null
}): Promise<void> => {
  try {
    const scopedKey = await getScopedStorageKey(AUTH_SESSION_STORAGE_KEY, {
      requireUserScope: true,
      userId: params.userId,
    })
    if (scopedKey == null) {
      return
    }

    if (!params.isAuthenticated) {
      await AsyncStorage.removeItem(scopedKey)
      return
    }

    await AsyncStorage.setItem(scopedKey, '1')
  } catch {
    // Best-effort only. Auth state still comes from Auth0 at runtime.
  }
}
